import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const Section = styled.section`
  background: ${theme.colors.black};
  text-align: center;
  padding: 7rem 8%;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 800px;
    height: 800px;
    background: radial-gradient(
      circle,
      rgba(253, 131, 96, 0.1) 0%,
      transparent 60%
    );
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 1;
  }
`;

export const SectionTag = styled.span`
  display: inline-block;
  color: ${theme.colors.orange};
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
`;

export const SectionTitle = styled.h2`
  font-family: ${theme.fonts.display};
  font-size: clamp(2rem, 3.5vw, 2.9rem);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: white;
  max-width: 640px;
  margin: 0 auto 1rem;
`;

export const SectionSub = styled.p`
  color: rgba(255, 255, 255, 0.5);
  font-size: 1rem;
  line-height: 1.7;
  margin: 0 auto 3rem;
`;

export const StoreBtns = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

export const StoreBtn = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: 0.85rem 1.8rem;
  border-radius: 12px;
  text-decoration: none;
  color: white;
  transition: all 0.25s;

  &:hover {
    background: rgba(253, 131, 96, 0.15);
    border-color: rgba(253, 131, 96, 0.4);
    transform: translateY(-2px);
  }
`;

export const StoreBtnIcon = styled.div`
  font-size: 1.7rem;
`;

export const StoreBtnText = styled.div`
  small {
    display: block;
    font-size: 0.62rem;
    color: rgba(255, 255, 255, 0.45);
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  strong {
    display: block;
    font-size: 1rem;
    font-family: ${theme.fonts.display};
    font-weight: 700;
  }
`;

export const Reassurance = styled.div`
  margin-top: 2rem;
  color: rgba(255, 255, 255, 0.3);
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.8rem;
  flex-wrap: wrap;

  span::before {
    content: '✓  ';
    color: ${theme.colors.orange};
  }
`;
